import React from "react";
import {
  Table,
  TableHead,
  TableHeaderCell,
  TableBody,
  TableRow,
  TableCell,
  Button,
  Text,
} from "@tremor/react";
import { TrashIcon, PencilSquareIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getIconFromName } from "../../components/IconPicker";

const ProfilesTable = ({ profiles, onDelete, deviceCounts }) => {
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableHeaderCell>Name</TableHeaderCell>
          <TableHeaderCell>Source</TableHeaderCell>
          <TableHeaderCell>Devices</TableHeaderCell>
          <TableHeaderCell></TableHeaderCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {profiles.map((profile) => (
          <TableRow key={profile._id}>
            <TableCell>
              <Link
                to={`/profiles/${profile._id}/settings`}
                className="inline-flex items-center gap-2 text-tremor-brand hover:underline hover:underline-offset-4"
              >
                <span className="tremor-Icon-root inline-flex flex-shrink-0 items-center justify-center rounded-tremor-default bg-blue-500 text-white w-7 h-7">
                  <FontAwesomeIcon
                    icon={getIconFromName(profile.image || "microchip")}
                    className="w-4 h-4"
                  />
                </span>
                {profile.name}
              </Link>
            </TableCell>
            <TableCell>{profile.source?.name ?? '—'}</TableCell>
            <TableCell>
              <Text className="text-sm text-tremor-content dark:text-dark-tremor-content">
                {deviceCounts[profile._id] || 0}
              </Text>
            </TableCell>
            <TableCell>
              <div className="flex items-center gap-1">
                <Link to={`/profiles/${profile._id}/settings`}>
                  <Button variant="secondary" size="xs" icon={PencilSquareIcon} title="Edit profile"></Button>
                </Link>
                <Button variant="secondary" color="red" size="xs" onClick={() => onDelete(profile._id)} icon={TrashIcon} title="Delete profile"></Button>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default ProfilesTable;
